module.exports = __webpack_public_path__ + "static/img/医保挂账icon@2x.473556a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/医保挂账icon@2x.png
// module id = 800
// module chunks = 382